import React from "react";
import { Link } from "react-router-dom";

import { generateEmail } from "../../../util/email.js";

import { HELP_EMAIL_ADDRESS } from "../../../constants.js";

/**
 * @typedef {import("../../../jsdoc/OrdersListItem.js").OrdersListItem} OrdersListItem
 */

/**
 * OrderEntry Component
 * @param {Object} props
 * @param {OrdersListItem} props.item
 * @returns {React.JSX.Element}
 */
export default function OrderEntry({ item, user }) {
  const emailAll = generateEmail({
    recipientList: item.chEmailsConcatenated.trim(),
    ccList: HELP_EMAIL_ADDRESS,
    bccList: HELP_EMAIL_ADDRESS,
    subject: `Customer Question for Order Number: ${item.orderNumber}, STN: ${item.stnSeq}`,
    body: `Hi ${item.companyName} (${item.chDisplayName}),\n\n<ADD YOUR MESSAGE HERE>\n\nFrom:\n${user.firstName} ${user.lastName}`,
  });

  const emailSEWP = generateEmail({
    recipientList: HELP_EMAIL_ADDRESS,
    subject: `Customer Question for Order Number: ${item.orderNumber}, STN: ${item.stnSeq}`,
    body: `Hi SEWP,\n\n<ADD YOUR MESSAGE HERE>\n\nFrom:\n${user.firstName} ${user.lastName}`,
  });

  return (<tr role="row" className="order-entry-row">
      <th role="rowheader">
        <a href={`#/detail/${item.stnSeq}`} title={`Go to the detail page for ${item.stnSeq}`}>
          {item.stnSeq}
        </a>
      </th>
      <td className="text-center" role="gridcell">
        {item.orderNumber}
      </td>
      {item.rfqSeqFlag === 1 ? (<td className="text-center" role="gridcell">
          <a href={`../sewp5public/detail.html?rs=${item.rfqSeq}`}>{item.rfqSeq}</a>
        </td>) : (<td className="text-center" role="gridcell" title="You don't have access to this RFQ.">
          {item.rfqSeq}
        </td>)}
      <td className="text-center" role="gridcell">
        <Link to={`/sewp5public/contractholders#/detail/${item.chInfoSeq}`}>
          {item.companyName} ({item.chDisplayName})
        </Link>
      </td>
      <td className="text-center" role="gridcell">
        {item.awardDate}
      </td>
      <td className="text-center" role="gridcell">
        {item.expDeliveryDate}
      </td>
      <td className="text-center" role="gridcell">
        {item.totalAmountJSON}
      </td>
      <td className="text-center" role="gridcell">
        {item.orderStatusDisplay}
      </td>
      <td className="text-center" role="gridcell">
        <ul className="list-unstyled">
          <li className="td-box-centered">
            <a href={emailAll}>Contract Holder &amp; SEWP</a>
          </li>
          <li className="td-box-centered">
            <a href={emailSEWP}>SEWP Only</a>
          </li>
        </ul>
      </td>
    </tr>);
}
